export default __webpack_public_path__ + "static/media/brand_14.d7b10908.png";